"use strict";

import setupSwiper from "../utils/SetupSwiper";

document.addEventListener("DOMContentLoaded", () => {
    // INTERNAL LINKS
    let bannerSlidingImages = document.querySelectorAll(
        ".swiper__banner-rotating"
    );
    bannerSlidingImages.forEach((block) => {
        let thisID = block.id;
        let thisSwiper = setupSwiper(thisID, {
            spaceBetween: 16,
            slidesPerView: 1,
            speed: 1000,
            disableInteraction: true,
            autoplay: {
                delay: 4000,
            },
            effect: "fade",
            fadeEffect: {
                crossFade: true,
            },
            loop: true,
        });
    });

    // INTERNAL LINKS
    let internalLinksBlock = document.querySelectorAll(
        ".component__internal-links .swiper"
    );
    internalLinksBlock.forEach((block) => {
        let thisID = block.id;
        const breakpoint = window.matchMedia("(min-width: 992px)");
        let thisSwiper;

        const breakpointChanged = () => {
            // console.log(breakpoint.matches);
            if (breakpoint.matches === true) {
                thisSwiper !== undefined && thisSwiper.destroy(true, true);
                return;
            } else if (breakpoint.matches === false) {
                return enableSwiper();
            }
        };

        const enableSwiper = () => {
            thisSwiper = setupSwiper(thisID, {
                spaceBetween: 16,
                slidesPerView: 1,
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                    },
                },
                pagination: {
                    el: "#" + thisID + "-pagination",
                },
            });
        };

        breakpoint.addEventListener("change", breakpointChanged);
        breakpointChanged();
    });

    // GALLERY
    let galleryBlocks = document.querySelectorAll(
        ".component__gallery .swiper"
    );
    galleryBlocks.forEach((block) => {
        let thisID = block.id;
        let thisSwiper = setupSwiper(thisID, {
            spaceBetween: 16,
            slidesPerView: 1,
            navigation: {
                nextEl: "#" + thisID + "-next",
                prevEl: "#" + thisID + "-prev",
            },
            pagination: {
                el: "#" + thisID + "-pagination",
                clickable: true,
            },
        });
    });

    // TEXT & MEDIA - SLIDER
    let textMediaSlider = document.querySelectorAll(
        ".component__text-media .swiper"
    );
    textMediaSlider.forEach((block) => {
        let thisID = block.id;
        let thisSwiper = setupSwiper(thisID, {
            slidesPerView: 1,
            pagination: {
                el: "#" + thisID + "-pagination",
                clickable: true,
            },
        });
    });

    // IMAGE SLIDER
    let imageSliderBlocks = document.querySelectorAll(
        ".component__image-slider .swiper"
    );
    imageSliderBlocks.forEach((block) => {
        let thisID = block.id;
        let numSlides = block.querySelectorAll(".swiper-slide").length;
        let thisSwiper = setupSwiper(thisID, {
            spaceBetween: 16,
            slidesPerView: 1,
            breakpoints: {
                768: {
                    slidesPerView: numSlides >= 2 ? 2 : numSlides,
                },
                992: {
                    slidesPerView: numSlides >= 3 ? 3 : numSlides,
                },
            },
            navigation: {
                nextEl: "#" + thisID + "-next",
                prevEl: "#" + thisID + "-prev",
            },
            pagination: {
                el: "#" + thisID + "-pagination",
                clickable: true,
            },
        });
    });

    // ADS - MPU
    let mpuAdBlocks = document.querySelectorAll(
        ".component__partner-ads.ad__mpu .swiper"
    );
    mpuAdBlocks.forEach((block) => {
        let thisID = block.id;
        let thisSwiper = setupSwiper(thisID, {
            spaceBetween: 16,
            autoplay: {
                delay: 3000,
            },
            loop: true,
            slidesPerView: 1,
            centerInsufficientSlides: true,
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    spaceBetween: 32,
                },
                992: {
                    slidesPerView: 4,
                    spaceBetween: 48,
                },
            },
        });
    });

    // ADS - LEADERBOARD
    let leaderboardAdBlocks = document.querySelectorAll(
        ".component__partner-ads.ad__leaderboard .swiper"
    );
    leaderboardAdBlocks.forEach((block) => {
        let thisID = block.id;
        let thisSwiper = setupSwiper(thisID, {
            spaceBetween: 16,
            autoplay: {
                delay: 3000,
            },
            loop: true,
            slidesPerView: 1,
            centerInsufficientSlides: true,
        });
    });

    // LATEST NEWS
    let latestNewsBlocks = document.querySelectorAll(
        ".component__latest-news .swiper"
    );
    latestNewsBlocks.forEach((block) => {
        let thisID = block.id;
        let thisSwiper = setupSwiper(thisID, {
            spaceBetween: 16,
            slidesPerView: 1,
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                992: {
                    slidesPerView: 3,
                },
            },
            navigation: {
                nextEl: "#" + thisID + "-next",
                prevEl: "#" + thisID + "-prev",
            },
            pagination: {
                el: "#" + thisID + "-pagination",
                clickable: true,
            },
        });
    });

    // MORE VACANCIES
    let moreVacanciesBlocks = document.querySelectorAll(
        ".component__jobs .swiper"
    );
    moreVacanciesBlocks.forEach((block) => {
        let thisID = block.id;
        let thisSwiper = setupSwiper(thisID, {
            spaceBetween: 16,
            slidesPerView: 1,
            navigation: {
                nextEl: "#" + thisID + "-next",
                prevEl: "#" + thisID + "-prev",
            },
            pagination: {
                el: "#" + thisID + "-pagination",
                clickable: true,
            },
        });
    });

    // SPACES TO LET
    let spacesToLetImages = document.querySelectorAll(
        ".card__property .swiper"
    );
    spacesToLetImages.forEach((block) => {
        let thisID = block.id;
        let thisSwiper = setupSwiper(thisID, {
            spaceBetween: 16,
            slidesPerView: 1,
            pagination: {
                el: "#" + thisID + "-pagination",
                clickable: true,
            },
        });
    });
    let propertyBanners = document.querySelectorAll(
        ".property__banner .swiper"
    );
    propertyBanners.forEach((block) => {
        let thisID = block.id;
        let thisSwiper = setupSwiper(thisID, {
            slidesPerView: 1,
            navigation: {
                nextEl: "#" + thisID + "-next",
                prevEl: "#" + thisID + "-prev",
            },
            pagination: {
                el: "#" + thisID + "-pagination",
                clickable: true,
            },
        });
    });
});
